import { Button, buttonClasses, styled } from "@mui/material"
import {
  FILTER_FIELD_HEIGHT,
  filterFieldActiveBorderColor,
  filterFieldBorderColor,
} from "./filterField.conf"

export const FilterFieldButton = styled(Button)(
  ({ theme: { spacing, palette, typography } }) => ({
    minHeight: FILTER_FIELD_HEIGHT,
    paddingBlock: 0,
    paddingInline: spacing(1.75),
    borderColor: filterFieldBorderColor(palette),
    color: palette.common.darkBlue,
    backgroundColor: palette.common.white,
    fontSize: typography.pxToRem(16),
    fontWeight: 400,
    "&:hover": {
      borderColor: filterFieldActiveBorderColor(palette),
      backgroundColor: palette.common.white,
    },
    [`&.${buttonClasses.contained}`]: {
      border: `1px solid ${filterFieldBorderColor(palette)}`,
      color: palette.common.darkBlue,
      backgroundColor: palette.common.lightBlue,
      fontSize: typography.pxToRem(14),
      fontWeight: 500,
      "&:hover": {
        borderColor: filterFieldActiveBorderColor(palette),
        backgroundColor: palette.common.lightBlue,
      },
    },
    "&:focus-visible, &:has(:focus-visible)": {
      borderColor: filterFieldActiveBorderColor(palette),
    },
  }),
) as typeof Button
